module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/mage2-fe8851d2ffc9db7b9482dd294296fdc1.png";